<template>
    <h3 class="mt-2 text-sm font-semibold text-primary">
        <slot />
    </h3>
</template>
